"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Deserializes an interaction object from INTERACTION_CHANGED_EVENT to an EcsInteraction object
 * @param {Object} dto - The interaction object
 **/
const deserializeInteraction = (dto) => {
    const interaction = {
        interactionId: dto.ID
    };
    const interactionVariables = dto.InteractionVariables && dto.InteractionVariables.InteractionVariableInstance;
    if (interactionVariables) {
        interaction.interactionVariables = mapInteractionVariables(dto.InteractionVariables && dto.InteractionVariables.InteractionVariableInstance);
    }
    return interaction;
};
const mapInteractionVariables = (variables = []) => {
    const variablesArray = Array.isArray(variables) ? variables : [variables];
    return variablesArray.map(variable => {
        return {
            id: variable.ID,
            name: variable.Name,
            value: variable.Value,
            type: variable.Type,
            description: variable.Description,
            typeId: variable.TypeID
        };
    });
};
exports.default = deserializeInteraction;
